import { render } from "./kTDatatableLeft.vue?vue&type=template&id=18baf5e8&ts=true"
import script from "./kTDatatableLeft.vue?vue&type=script&lang=ts"
export * from "./kTDatatableLeft.vue?vue&type=script&lang=ts"

import "./kTDatatableLeft.vue?vue&type=style&index=0&id=18baf5e8&lang=scss"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__